<template>
    <b-form-group v-if="optKemasanEmas.length != 0" label="Jenis Kemasan Emas">
        <b-row no-gutters>
            <b-col>
                <multiselect name="kemasanEmas" v-model="input.kemasanEmas" :options="optKemasanEmas"
                    :disabled="optKemasanEmas.length == 0" :internal-search="true" :allow-empty="true" deselect-label=""
                    select-label="" label="name" track-by="name" placeholder="-- Please select an option --" />
            </b-col>

            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ? false : true">

            </b-col>
        </b-row>
    </b-form-group>
</template>
<script>
export default {
    props: {
        input: { required: true },
        optKemasanEmas: { required: true }
    },
}
</script>